import axios from "axios";
import React, { useState } from "react";
import Results from "./Results";
import "./Results.css";
import Photos from "./Photos";

export default function Search(props) {
  let [keyword, setKeyword] = useState("");
  let [results, setResults] = useState(null);
  let [photos, setPhotos] = useState(null);
  let name = props.name;

  function showKeyword(response) {
    console.log(response.data[0]);
    console.log(response.data[0].meanings[0].definitions[0].definition);
    setResults(response.data[0]);
  }

  function handleDictionnaryResponse(response) {
    console.log(response.data);
    setPhotos(response.data.photos);
  }

  function search(event) {
    event.preventDefault();

    let url = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;

    axios.get(url).then(showKeyword);

    let pexelsApi = "563492ad6f91700001000001106658ca37e448e9a067402bab99e92c";
    let pexelsUrl = `https://api.pexels.com/v1/search?query=${keyword}&per_page=10`;
    let headers = { Authorization: `Bearer ${pexelsApi}` };

    axios.get(pexelsUrl, { headers: headers }).then(handleDictionnaryResponse);
  }

  function handleSubmit(event) {
    event.preventDefault();
    setKeyword(event.target.value);
  }

  return (
    <div className="container">
      <div row>
        <div className="container-fluid">
          <h1>{name}</h1>
          <h2>What word do you want to look up ?</h2>
          <form className="form-dictionnary" onSubmit={search}>
            <input type="search" placeholder="Search" onChange={handleSubmit} />
            <button class="btn btn-secondary" type="submit">
              Search
            </button>
          </form>
        </div>
      </div>
      <Results results={results} />
      <Photos photos={photos} />
    </div>
  );
}
